import React, { useState } from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';

const DEFAULT_PROFILE_PHOTO_URL = 'https://d185jh8djxl1sd.cloudfront.net/assets/placeholder/person_placeholder.png';

const UserLabel = ({ name, userLink, profileImageUrl, subText }) => {
  const [imageUrl, setImageUrl] = useState(profileImageUrl || DEFAULT_PROFILE_PHOTO_URL);

  const handleErrorImageLoad = () => {
    setImageUrl(DEFAULT_PROFILE_PHOTO_URL);
  };

  return (
    <a className={styles.container} href={userLink}>
      <img onError={handleErrorImageLoad} className={styles.profileImage} src={imageUrl} alt={name} />
      <div className={styles.userData}>
        <div className={styles.userName}>{name}</div>
        <div className={styles.subText}>{subText}</div>
      </div>
    </a>
  );
};

UserLabel.propTypes = {
  name: string,
  userLink: string,
  profileImageUrl: string,
  subText: string
};

UserLabel.defaultProps = {
  subText: '',
  name: '',
  userLink: '/',
  profileImageUrl: DEFAULT_PROFILE_PHOTO_URL
};

export default UserLabel;
